import { action, computed, makeObservable, observable } from 'mobx'

import { ExtendedColumnKey } from '@new/__global/components/FiltersFramework'
import { extendedColumns } from '@new/domains/fastBookingsTapeChart/components/ExtendedColumns/ExtendedColumns.utils'
import { arrivalsModeStore } from '@new/domains/fastBookingsTapeChart/stores/ArrivalsModeStore'
import { fastBookingsTapeChartFiltersStore } from '@new/domains/fastBookingsTapeChart/stores/FastBookingsTapeChartFiltersStore'

import { ExtendedColumnConfigProps } from './ExtendedColumns.types'
import { getExtendedColumnWidth } from './ExtendedColumns.utils'

class _extendedColumnsStore {
  hoveredBookingId?: string

  constructor() {
    makeObservable<_extendedColumnsStore, 'columns'>(this, {
      hoveredBookingId: observable,
      columns: computed,
      activeColumns: computed,
      isSortableExtendedColumnsActive: computed,
      isExtendedColumnsActive: computed,
      extendedColumnsWidth: computed,
      setHoverBookingById: action.bound,
    })
  }

  private get columns(): ExtendedColumnConfigProps[] {
    void [fastBookingsTapeChartFiltersStore.extendedColumnsView]

    const activeExtendedColumns =
      extendedColumns.filter(extendedColumn =>
        (fastBookingsTapeChartFiltersStore.extendedColumnsView ?? []).includes(
          extendedColumn.columnKey as ExtendedColumnKey,
        ),
      ) ?? []

    return activeExtendedColumns ?? []
  }

  get activeColumns(): ExtendedColumnConfigProps[] {
    const { arrivalsModeColumns } = arrivalsModeStore

    return this.columns.concat(arrivalsModeColumns)
  }

  get isSortableExtendedColumnsActive(): boolean {
    return !!this.columns.length
  }

  get isExtendedColumnsActive(): boolean {
    return !!this.activeColumns.length
  }

  get extendedColumnsWidth(): number {
    return getExtendedColumnWidth(this.activeColumns)
  }

  setHoverBookingById(bookingId?: string) {
    this.hoveredBookingId = bookingId
  }
}

export const extendedColumnsStore = new _extendedColumnsStore()
